<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 order-header">
    <stats-card header-color="green">
      <template slot="header">
        <div class="card-icon">
          <md-icon>equalizer</md-icon>
        </div>
        <p class="category">TOTAL RELOADS (IN RANGE)</p>
        <h3 class="title">{{ formatBalance(reloadAmount) }}</h3>
      </template>
    </stats-card>
  </div>
  <div class="md-layout-item md-size-50 order-header">
    <stats-card header-color="green">
      <template slot="header">
        <div class="card-icon">
          <md-icon>equalizer</md-icon>
        </div>
        <p class="category">TOTAL BALANCES (ALL-TIME)</p>
        <h3 class="title">
          <h3 class="title">{{ formatBalance(currentBalance) }}</h3>
        </h3>
      </template>
    </stats-card>
  </div>
    <div class="md-layout-item md-size-100">
      <div class="md-layout">
        <div class="md-layout-item">
          <date-range-picker v-model="calendarPeriod" :startDate="calendarPeriod.startDate" :endDate="calendarPeriod.endDate" :locale-data="calendarLocale" :ranges="ranges" opens="right">
            <md-input v-model="calendarPeriod" slot-scope="picker">Days Interval</md-input>
          </date-range-picker>
          <div>
            <md-button class="exportBtns" @click="downloadCsvData" v-if="csvUsers == null">
              {{ this.downloadTitle }}
            </md-button>
            <md-button v-if="csvUsers != null">
              <download-csv class="exportBtns" name="user-export.csv" :data="csvUsers" :fields="exportFields" :labels="exportLabels">
                Download Report
                <md-icon>cloud_download</md-icon>
              </download-csv>
            </md-button>
          </div>
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>group</md-icon>
              </div>
              <h4 class="title">Users</h4>
            </md-card-header>
            <md-card-content>
              <md-table id="usersInfoTable" :value="summaries" class="paginated-table table-striped table-hover" 
              :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder" @md-selected="userSelected">
                <md-table-toolbar>
                  <md-field>
                    <md-input type="search" class="mb-3" clearable style="width: 200px" placeholder="Search Name or Email" v-model="summaryHandleProps.searchQuery">
                    </md-input>
                  </md-field>
                </md-table-toolbar>
                <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                  <md-table-cell md-label="ID" md-sort-by="id"> {{ item.id }} </md-table-cell>
                  <md-table-cell md-label="Name"> {{ name(item) }} </md-table-cell>
                  <md-table-cell md-label="Email" md-sort-by="email"> {{ item.email }} </md-table-cell>
                  <md-table-cell md-label="Phone Number"> {{ formatNumber(item.phone_number) }} </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <div class="">
                <p class="card-category">
                  Showing {{ summary_from + 1 }} to {{ summary_to }} of {{ summary_total }} users
                </p>
              </div>
              <pagination class="pagination-no-border pagination-success" v-model="summaryHandleProps.currentPage" :per-page="summaryHandleProps.perPage" :total="summary_total">
              </pagination>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IntToMoneyFormatter from "@/mixins/money-formatter-mixin.js"
import { Pagination, StatsCard } from "@/components";
import PhoneFormatter from "@/mixins/phone-formatter-mixin.js"
import DateRangePicker from 'vue2-daterange-picker'
import JsonCSV from 'vue-json-csv'
import moment from "moment"
import { debounce } from 'lodash';

export default {
  name: "UsersList",
  mixins: [ IntToMoneyFormatter, PhoneFormatter ],
  components: {
    Pagination,
    StatsCard,
    DateRangePicker,
    'downloadCsv': JsonCSV
  },
  computed: {
    summary_from() {
      return this.summaryHandleProps.perPage * (this.summaryHandleProps.currentPage - 1);
    },
    summary_to() {
      let highBound = this.summary_from + this.summaryHandleProps.perPage;
      if (this.summary_total < highBound) {
        highBound = this.summary_total;
      }
      return highBound;
    },
    summary_total() {
      return this.summaries_pagination.total;
    },
    downloadTitle() {
      return (this.downloadingCsv ? "Downloading..." : "Download All Data")
    }
  },
  data() {
    return {
      currentSort: "last_order",
      currentSortOrder: "desc",
      summaries: {},
      summaries_pagination: {
        total: 0
      },
      summaryHandleProps: {
        searchQuery: "",
        currentPage: 1,
        perPage: 50
      },
      formatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }),
      calendarPeriod: {
        startDate: moment('2018', 'YYYY').startOf('year'),
        endDate: moment().endOf('day')
      },
      dateStart: moment('2018', 'YYYY').startOf('year'),
      dateEnd: moment().endOf('day'),
      calendarLocale: {
        direction: 'ltr',
        format: 'MM/DD/YYYY',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 0,
        showWeekNumbers: true
      },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'This month': [moment().startOf('month'), moment().endOf('month')],
        'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'All Time': [moment('2018', 'YYYY').startOf('year'), moment().endOf('day')]
      },
      csvUsers: null,
      downloadingCsv: false,
      exportFields: ['id', 'first_name', 'last_name', 'username', 'email', 'order_count', 'merchant_count', 'spent',
        'saved', 'balance', 'verified', 'first_order', 'last_order'
      ],
      exportLabels: {
        id: 'ID',
        first_name: 'First Name',
        last_name: 'Last Name',
        username: 'Username',
        email: 'Email',
        order_count: '# Orders',
        merchant_count: '# Merchants Visited',
        spent: 'Spent',
        saved: 'Saved',
        balance: 'Loaded Balance',
        verified: 'Phone Verified',
        first_order: 'First Order',
        last_order: 'Last Order'
      },
      reloadAmount: 0,
      currentBalance: 0
    }
  },
  created() {
    this.debounceUserSummaries = debounce(this.getUserSummaries, 350)
    this.getUserSummaries()
  },
  methods: {
    getUserSummaries() {
      this.resetCsvButtons()

      this.$http.secured.get(`/v2/admins/app_users` +
          `?page=${this.summaryHandleProps.currentPage}` +
          `&page_size=${this.summaryHandleProps.perPage}` +
          `&q=${this.summaryHandleProps.searchQuery}` +
          `&order=${this.currentSort}&desc=${ (this.currentSortOrder == 'desc') }`)
        .then(this.summaryData)
        .catch(error => alert(error))
    },
    getBalanceSummaries() {
      this.reloadAmount = 0
      this.currentBalance = 0

      this.$http.secured.get(`/v2/wallets/summary?start_date=${this.dateStart}&end_date=${this.dateEnd}`)
      .then((response) => {
        this.reloadAmount = response.data.reload_amount
        this.currentBalance = response.data.balances
      })
      .catch(error => alert(error))
    },
    summaryData(response) {
      this.summaries = response.data.app_users;
      this.summaries_pagination.total = response.data.meta.total

      this.getBalanceSummaries()
    },
    formatDouble(value) {
      if (value) {
        var parsedValue = parseFloat(value)
        return this.formatter.format(parsedValue)
      }
      else {
        return "-"
      }
    },
    name(item) {
      if (!this.isEmpty(item.first_name || !this.isEmpty(item.last_name))) {
        return (item.first_name + " " + item.last_name)
      } else if (!this.isEmpty(item.username)) {
        return item.username
      } else {
        return "No Name"
      }
    },
    isEmpty(str) {
      return (!str || 0 === str.length)
    },
    userSelected(item) {
      this.$router.push({name: 'User Detail', params: { id: item.id } })
    },
    downloadCsvData() {
      if (this.downloadingCsv) {
        return
      }

      this.downloadingCsv = true
      this.$http.secured.get(`/v1/app_users` +
          `?page=${1}` + `&page_count=${100000}` + `&is_report=true` +
          `&q=${this.summaryHandleProps.searchQuery}` +
          `&start_date=${this.dateStart}&end_date=${this.dateEnd}`)
        .then((response) => {
          this.csvUsers = response.data.app_users
          this.csvUsers.forEach((item, index) => {
            item.first_order = moment(item.first_order).format('MM/DD/YY hh:mm A')
            item.last_order = moment(item.last_order).format('MM/DD/YY hh:mm A');
          })
        })
        .catch(error => alert(error))
        .finally(() => this.downloadingCsv = false)
    },
    resetCsvButtons() {
      this.csvUsers = null
      this.downloadingCsv = false
    }
  },
  watch: {
    summaryHandleProps: {
      handler() {
        this.debounceUserSummaries()
      },
      deep: true
    },
    currentSortOrder: {
      handler() {
        this.debounceUserSummaries()
      },
      deep: true
    },
    calendarPeriod: {
      handler() {
        this.dateStart = moment(this.calendarPeriod.startDate).startOf('day')
        this.dateEnd = moment(this.calendarPeriod.endDate).endOf('day')
        this.debounceUserSummaries()
      },
      deep: true
    }
  },
  filters: {
    moment: function(date) {
      if (date) {
        return moment(date).format('MM/DD/YY');
      }
      else {
        return "N/A"
      }
    }
  }
}
</script>

<style lang="scss">
#usersInfoTable > div > table > thead > tr > th > .md-ripple {
  z-index: unset !important;
}

#usersInfoTable tr td:nth-child(2),
td:nth-child(3),
td:nth-child(10),
td:nth-child(11) {
  max-width: 1% !important;
  white-space: nowrap;
}

#usersInfoTable.paginated-table .md-table-cell:last-child .md-table-cell-container, .paginated-table .md-table-head:last-child {
  text-align: unset !important;
  justify-content: left !important;
}
</style>